import React from 'react'
import dinero from 'dinero.js'

const Currency = ({ amount }) => {
  const price = dinero({ amount: Math.round(amount * 100), currency: 'USD' })

  return price.toFormat('$0,0.00')
}

export default Currency
